export function parseRoles(raw: string | null | undefined): string[] {
  if (raw == null || raw === '') return [];
  const out: string[] = [];
  for (const part of String(raw).split(',')) {
    const token = part
      .normalize('NFKC')
      .trim()
      .toLowerCase()
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[\s-]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
    if (token && !out.includes(token)) out.push(token);
  }
  return out;
}

export function hasRole(raw: string | null | undefined, role: string): boolean {
  return parseRoles(raw).includes(role.trim().toLowerCase());
}
